import countriesApiService from '@/services/api/Countries'

const emptyModel = {
  id: null,
  name: null,
  code: null,
  chartering: null,
  charter_end_date: null
}

export default class Country {
  static api = countriesApiService
  static emptyModel = emptyModel
}
